import { Navigate, Route } from 'react-router';
import SubNavigationLayout from '../../common/components/SubNavigationLayout';
import ErrorBoundary from '../../common/error/ErrorBoundary';
import Admins from '../administrators/Admins';
import Apartments from '../apartments/Apartments';
import SubMenu from '../navigation/SubMenu';
import GeneralSettings from '../settings/GeneralSettings';
import SwishSettings from '../settings/SwishSettings';

/**
 * Settings feature routes
 * Base path: settings/
 */
export const settingRoutes = (
    <Route
        element={
            <SubNavigationLayout
                subNavigation={
                    <ErrorBoundary key="/submenu/settings">
                        <SubMenu parentId="settings" />
                    </ErrorBoundary>
                }
            />
        }
    >
        <Route index element={<Navigate to="admins" replace />} />
        <Route
            path="general"
            element={
                <ErrorBoundary key="settings">
                    <GeneralSettings />
                </ErrorBoundary>
            }
        />
        <Route
            path="admins"
            element={
                <ErrorBoundary key="settings/admins">
                    <Admins />
                </ErrorBoundary>
            }
        />
        <Route
            path="apartments"
            element={
                <ErrorBoundary key="settings/apartments">
                    <Apartments />
                </ErrorBoundary>
            }
        />
        <Route
            path="swish"
            element={
                <ErrorBoundary key="settings/swish">
                    <SwishSettings />
                </ErrorBoundary>
            }
        />
    </Route>
);
